import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";
import { CvPortalJob as CvPortalJob } from "./getJobs";

export interface GetJobFullParameters extends NextApiParams {
  konsernid: number;
  typeRelated: number;
  idRelated: number;
  languageId: number;
  terminalId?: string;
  sesjonsId?: string;
  consultantMode?: boolean;
}

export type getJobFull = (
  args: GetJobFullParameters
) => Promise<CvPortalJobFull>;

export const getJobFull = withNextApi<CvPortalJobFull, GetJobFullParameters>(
  "/cvp/CvpGetJobFull",
  { method: "GET" }
);

export interface CvPortalJobFull extends BackendResponse {
  job: CvPortalJob;
  extra: CvPortalJobExtra;
  jobInfo: JobInfo;
  jobText: JobtekstFullRow;
  youtubeUrl: string;
  pictures: JobPicture[];
}

export interface JobPicture {
  type_relatertfil: number;
  id_relatertfil: number;
  id_dokumenter: number;
  comment: string;
  guid: string;
  priority: number;
  name: string;
  filetype: string;
  deleted: boolean | null;
  version: number | null;
}

export interface CvPortalJobExtra extends BackendResponse {
  leaderPosition: boolean;
  workPlace: string;
  commentWorkhours: string;
  refNumber: string;
  dueDateOverrideText: string;
  fromDate: string | null;
  externalApplicationUrl: string;
  agencyText: string;
  consultant: JobConsultant;
  customerCanBeContacted: boolean;
  customerContact: JobCustomerContact;
  customerInfo: JobCustomerInfo;
}

export interface JobConsultant {
  id: number;
  name: string;
  position: string;
  phone: string;
  email: string;
  emailHidden: boolean;
  pictureUrl: string;
}

export interface JobCustomerContact {
  contact: string;
  contactPosition: string;
  contactMobilePhone: string;
  contactInternalPhone: string;
  contactEmail: string;
}

export interface JobCustomerInfo {
  homePageUrl: string;
  facebook: string;
  twitter: string;
  linkedIn: string;
}

export interface JobInfo {
  type_relatertfil: number;
  id_relatertfil: number;
  annonser: Job[];
  uoppdaterteAnnonser: Job[];
  annonseperiode: boolean;
  annonseperiode_kommentar: string;
  arbeidssted: string;
  portalUrl: string;
  xmlUrl: string;
  finnXmlUrl: string;
  elapsedMilliseconds: number;
  utvidetProfilering: boolean;
  anonymKunde: boolean;
  kundeKanKontaktes: boolean;
  offentligSokerliste: boolean;
  vispaanettdato: string | null;
  lastFinnUpdate: string | null;
  nextAdText: JobtekstFullRow;
}

export interface Job {
  type_portaler: number;
  type_portaler_caption: string;
  avsluttet: boolean;
  forstOppdatert: string | null;
  sistOppdatert: string | null;
  fornyesAutomatisk: string | null;
  urlNettannonse: string;
  finnkode: number | null;
  errormessage: string;
  parametre: string;
}

export interface JobtekstFullRow {
  id: number;
  type_relatertfil: number;
  id_relatertfil: number;
  heading: string;
  jobtitle: string;
  ingress: string;
  generaltext: string;
  lastupdate: string | null;
  added: string | null;
}
